export const LOGIN_API_URLS = {
  SCHOOLFLAT: '/schoolFLAT/login',
  MATHFLAT: '/mathFLAT/login',
  NAVER_WORKS_OAUTH: '/oauth/teacher/naver-works/login',
  AIEP_LOGIN: '/v2/login/saml2/aiep',
}
